/**
 * TanStack Router: /performance/configuracoes/matriz
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceConfiguracoesMatrizPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceConfiguracoesMatrizPage from '@/app/performance/configuracoes/matriz/page'

/**
 * Route: /performance/configuracoes/matriz
 * Layout: _auth (authenticated)
 * Component: PerformanceConfiguracoesMatrizPage
 */
export const Route = createFileRoute('/_auth/performance/configuracoes/matriz')({
  component: PerformanceConfiguracoesMatrizPage,
})
